

const IMAGE_ICON = {
	icon: 'image',
	type: 'md-icon'
	}
const PDF_ICON = {
	icon: 'picture_as_pdf',
	type: 'md-icon',
  color: 'md-danger'
}
const XML_ICON = {
	icon: 'code',
	type: 'md-icon',
  color: 'md-primary'
}

const XLS_ICON = {
	icon: 'insert_chart',
	type: 'md-icon'
}

const DEFAULT_ICON = {
	icon: 'description',
	type: 'file',
}

const fileExtensionMap = {
	jpg: IMAGE_ICON,
	png: IMAGE_ICON,
	pdf: PDF_ICON,
	xls: XLS_ICON,
	xlsx: XLS_ICON,
  xml: XML_ICON
}

export default (link) => {
	const ext = (link || "").split('.').pop()
	return fileExtensionMap[ext] || DEFAULT_ICON
}


// WEBPACK FOOTER //
// ./src/utils/fileIcon.js